<template>
  <div class="fukidashi-title-components">
    <div class="fukidashi-title">
      {{title}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FukidashiTitle',
  props: {
    title: String,
  }
}
</script>
<style scoped lang="scss">
.fukidashi-title {
  padding: 20px 0px;
  border: 6px solid #ffce48;
  display: block;
  position: relative;
  z-index: 1;
  color: #e51c57;
  text-align: center;
  font-size: 14px;
  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin: 0;
  }
  &:after {
    right: 0;
    left: 0;
    margin: auto;
    bottom: -26px;
    border: 10px solid transparent;
    border-top: 10px solid #ffce48;
  }
}
</style>
